import { Epic, ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    ADD_NEW_INTERNAL_BANNER,
    AddNewInternalBanner
} from '../../../actions/bannersEdit/internal/addNewInternalBanner';
import { scrollToElementById } from '../../../service/ScrollHelpers';
import { EpicDeps } from '../../../service/StoreFactory';
import { State } from '../../../typings/state';

export const scrollToNewInternalBannerEpic: Epic<Action, Action, State, EpicDeps> = action$ => {
    return action$.pipe(
        ofType(ADD_NEW_INTERNAL_BANNER),
        mergeMap((action: AddNewInternalBanner) => {
            scrollToElementById(action.bannerId);

            return EMPTY;
        })
    );
};
